import { render, staticRenderFns } from "./base-select-visible.vue?vue&type=template&id=2355ccb1&"
import script from "./base-select-visible.vue?vue&type=script&lang=js&"
export * from "./base-select-visible.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports